export default {"src":"/_next/static/media/UNG.6e361108.svg","height":18,"width":18};